import { render, staticRenderFns } from "./setrealinfo.vue?vue&type=template&id=b12273b8&scoped=true"
import script from "./setrealinfo.vue?vue&type=script&lang=js"
export * from "./setrealinfo.vue?vue&type=script&lang=js"
import style0 from "./setrealinfo.vue?vue&type=style&index=0&id=b12273b8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b12273b8",
  null
  
)

export default component.exports